import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Collapse from '@material-ui/core/Collapse'
import Switch from '@material-ui/core/Switch'
import IconButton from '@material-ui/core/IconButton'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import SliderTransparency from './SliderTransparency'
import SliderDissolve from './SliderDissolve'
import SliderFilter from './SliderFilter'
import SliderDatetimeContainer from '../containers/SliderDatetimeContainer'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { makeGetLayerDisabled } from '../selectors/layerDisabledSelector'
import format from 'date-fns/format'
import getDateFromTimeIso from '../utility/getDateFromTimeIso'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import Legend from './Legend'
import transform from '../transforms'
import PlanetList from './PlanetList'
import PlanetActions from '../redux/planetRedux'
import PlanetPlusPlusActions from '../redux/planetPlusPlusRedux'
import ExportButton from './ExportButton'
import exportLayer from '../redux/exportLayerDuck'

const styles = theme => ({
  card: {
    maxWidth: 400,
    marginTop: 5
  },
  item: {
    paddingTop: '0px',
    paddingBottom: '0px',
    paddingLeft: '0px',
    paddingRight: '0px'
  },
  media: {
    height: 194
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  flexGrow: {
    flex: '1 1 auto'
  },
  switchRoot: {
    height: '0px'
  }
})

class ServiceLayersListItem extends PureComponent {
  state = {
    expanded: false
  }

    handleExportLayerRequest = ({ format }) => {
    const { actions, layer: { exportId, datetimeId } } = this.props

        actions.exportLayerRequest({ exportId, datetimeId, format })
  }

  handleExpandClicked = () => {
    const { expanded } = this.state
    this.setState({ expanded: !expanded })
  }

  handleLayerToggled = () => {
    const { handleLayerToggled, layer } = this.props

    handleLayerToggled(layer.name)
  }

  handleClick = (feature) => {
    const { actions } = this.props

    actions.planetUpdateUrls(feature)
  }

  handlePlusPlusClick = (feature) => {
    const { actions } = this.props

    actions.planetUpdatePlusPlusUrls(feature)
  }

  render() {
    const {
      classes,
      layer,
      handleLayerToggled,
      layersRendered,
      layerDisabled,
      datetime
    } = this.props

    if (layer.hidden) {
      return null
    }

    const expanded = layer.open || this.state.expanded

    const layerRendered = layersRendered.includes(layer.name)

    return [
      <ListItem key='layerToggle' className={classes.item}>
        {!layer.disableToggle &&
          <Switch
            key='switch'
            onClick={this.handleLayerToggled}
            checked={layerRendered}
            disabled={layerDisabled}
            color='primary'
          />
        }
        {!layer.hideLabel &&
          <Fragment>
            <ListItemText key='layerLabel' style={{ padding: '0px' }} secondary={<small>{layer.label || layer.name}</small>} />
            <ListItemText
              style={{ textAlign: 'right', padding: '0px' }}
              secondary={<small>{layerDisabled ? 'Not available' : transform(datetime, layer.datetimeTransform) || null}</small>}
            />
              {layer.exportId &&
               <Fragment>
                 <ExportButton onClick={this.handleExportLayerRequest} />              
               </Fragment>
            }
            <IconButton
              key='expandButton'
              className={classes.expand}
              onClick={this.handleExpandClicked}
              aria-expanded={expanded}
              aria-label='Show more'
            >
              {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          </Fragment>
        }
      </ListItem>,      
      <Collapse key='collapse' in={expanded} unmountOnExit>
        <ListItem key='legendItem' className={classes.item} >
          <Legend layer={layer} key={layer.name} />
        </ListItem>
        <ListItem key='layerTransparency'>
          <SliderTransparency
            layerName={layer.name}
            layerOpacity={layer.opacity}
            label={layer.transparencyLabel}
            marks={layer.transparencyMarks || {}}
            {...layer.layerOptions}
          />
        </ListItem>
        {layer.planetList &&
          <PlanetList onClick={this.handleClick} />
        }
        {layer.planetPlusPlusList &&
          <PlanetList onClick={this.handlePlusPlusClick} slice='planetPlusPlus' />
        }
        {layer.filter &&
          <ListItem key='filter'>
            <SliderFilter
              {...layer.filter}
              layerName={layer.name}
            />
          </ListItem>
        }
        <ListItem key='layerDatetime'>
          <SliderDatetimeContainer
            layerName={layer.name}
            datetimeId={layer.datetimeId}
            datetimeValue={transform(datetime, layer.datetimeTransform) || null}
          />
        </ListItem>
        {layer.name === 'MopraVector' &&
          <FormGroup row key='formGroup'>
            <FormControlLabel
              label='control'
              control={
                <Checkbox
                  checked={true}
                  onChange={() => console.log('checked')}
                  value="control"
                  color="primary"
                />
              }
            />
          </FormGroup>

        }
      </Collapse>
    ]
  }
}

const makeMapStateToProps = () => {
  const getDatetime = makeGetDatetime()
  const getLayerDisabled = makeGetLayerDisabled()

  const mapStateToProps = (state, ownProps) => {
    const { layer } = ownProps
    return {
      datetime: getDatetime(state, layer.datetimeId, getDateFromTimeIso),
      layerDisabled: getLayerDisabled(state, layer.name, layer.datetimeId, layer.secondary)
    }
  }

  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      // dataUpdated: (json, event) =>
      //   dispatch(DataActions.dataFulfilled(json, 'PlanetLabs', event)),
      exportLayerRequest: payload => dispatch(exportLayer.actions.exportLayerRequest(payload)),
      planetUpdateUrls: (feature) =>
        dispatch(PlanetActions.planetUpdateUrls(feature)),
      planetUpdatePlusPlusUrls: (feature) =>
        dispatch(PlanetPlusPlusActions.planetUpdatePlusPlusUrls(feature))
    }
  }
}

export default connect(makeMapStateToProps(), mapDispatchToProps)(
  withStyles(styles)(ServiceLayersListItem)
)



// WEBPACK FOOTER //
// ./src/components/ServiceLayersListItem.js